"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const _1 = require(".");
function default_1({ control, isFeeFree, errors, resetField, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const defaultCustomArr = (0, react_redux_1.useSelector)((state) => state.customDeliveries);
    const isTicket = (0, react_redux_1.useSelector)((state) => state.roomData.is_ticket);
    const resetPriceField = (index) => {
        const fieldNameArr = [];
        for (let i = index; i < 5; i++) {
            fieldNameArr.push(`custom_price_${i}`);
        }
        fieldNameArr.forEach(name => resetField(name));
    };
    //티켓체크했을때 배송비 날림
    (0, react_1.useEffect)(() => {
        dispatch((0, roomCreateStore_1.switchCustomDelivery)());
    }, [isTicket]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: defaultCustomArr.map((data, index) => {
            const { origin_price, order_count, name } = data;
            const defaultName = name || '';
            const defaultPrice = origin_price || '';
            const onCustomNameBlur = (name) => {
                dispatch((0, roomCreateStore_1.modifyCustom)({ name, index }));
            };
            const onCustomPriceBlur = (origin_price) => {
                dispatch((0, roomCreateStore_1.setCustomDeliveryInfo)({ origin_price, index }));
            };
            return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { position: 'relative', display: 'flex', flexDirection: 'column', rowGap: '4px' } }, { children: [(0, jsx_runtime_1.jsx)(_1.CustomCalculator, { index: index, control: control, isFeeFree: isFeeFree, defaultName: defaultName, defaultPrice: defaultPrice, onCustomNameBlur: onCustomNameBlur, onCustomPriceBlur: onCustomPriceBlur }), errors[`custom_name_${index}`] && ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1 error-dark" }, { children: errors[`custom_name_${index}`].message }))), defaultCustomArr.length > 1 && !order_count && ((0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ css: {
                            position: 'absolute',
                            top: '-8.5px',
                            right: '-8.5px',
                        }, onClick: () => {
                            resetPriceField(index);
                            dispatch((0, roomCreateStore_1.deleteCustom)(index));
                        } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.XCircleGraySvg, { css: {
                                width: '16px',
                                height: '16px',
                                borderRadius: '50%',
                                backdropFilter: 'blur(10px)',
                            } }) })))] }), `custom_calculator_${data.id}_${index}`));
        }) }));
}
exports.default = default_1;
